import { TTSProviders } from './tts';
import { STTProviders } from './stt';
import { LLMProviders } from './llm';

export const providers = {
  tts: TTSProviders,
  stt: STTProviders,
  llm: LLMProviders,
};

export * from './tts';
export * from './stt';
export * from './llm';